import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Box,
  MassageIcon,
  RecreationalIcon,
  TransportIcon,
  WellbeingIcon
} from 'edenred-ui';

import { BenefitType } from '@epi-constants/benefitTypes';

type MyChoiceBenefitTileProps = {
  types: string[];
  limit: number;
};

export const MyChoiceBenefitTile = ({
  types,
  limit
}: MyChoiceBenefitTileProps) => {
  const { t } = useTranslation();
  const { primaryFrontColor, sizeExtraSmall, gray50 } = useTheme();

  const iconByType: Record<string, ReactNode> = {
    [BenefitType.Recreational]: <RecreationalIcon color={primaryFrontColor} />,
    [BenefitType.Transport]: <TransportIcon color={primaryFrontColor} />,
    [BenefitType.Massage]: <MassageIcon color={primaryFrontColor} />,
    [BenefitType.Wellbeing]: <WellbeingIcon color={primaryFrontColor} />
  };

  const icons = types
    .map(type => iconByType[type.toLowerCase()])
    .filter(Boolean);

  if (!icons.length) {
    return <Box />;
  }

  return (
    <Box>
      <Box display="flex" gap={0.5} alignItems="center" mb={0.5}>
        {icons.map((icon, index) => (
          <Box key={`my-choice-icon-${index}`} display="inline-block">
            {icon}
          </Box>
        ))}
      </Box>
      <Box fontSize={sizeExtraSmall}>
        {t('containers.benefit_groups.my_choice.total_budget')}
      </Box>
      <Box display="flex" gap={0.5} alignItems="center">
        <Box fontSize={sizeExtraSmall}>{limit}</Box>
        <Box color={gray50}> €</Box>
      </Box>
    </Box>
  );
};
